<template>
  <div class="specified_commercial_transactions">
    <div class="row flex-center">
      <h1 class="col-md-12 title">特定商取引法について</h1>
      <div class="col-md-12 news-lists">
        <h2>事業者の名称</h2>
        <p>株式会社シュ-電</p>
        <h2>事業者の所在地</h2>
        <p>東京都江戸川区清新町一丁日3番3-1302号</p>
        <h2>責任者</h2>
        <p>宋光輝</p>
        <!-- <h2>連絡先</h2>
        <p><a href="http://jp.chargepop.net" target="_blank">http://jp.chargepop.net</a></p> -->
        <h2>連絡先</h2>
        <p>080-234-9260</p>
        <!-- <h2>利用料金</h2>
        <p><a href="http://jp.chargepop.net" target="_blank">http://jp.chargepop.net</a>でご確認できます。</p> -->
        <h2>営業時間</h2>
        <p>9:00-18:00</p>
        <h2>商品等の引き渡し時期</h2>
        <p>モバイルバッテリーは登録完了後、ご利用を頂けます。</p>
        <h2>支払い方法及び支払時期</h2>
        <p>
          日本発行のご本人様名義の VISA、MasterCard、JCB、AMEX、Payeasy、Konbini、Diners です。<br />
          お支払時期はお客様のカード会社によって引き落とし日は異なります。
        </p>
        <h2>各種オンラインペイメントでのお支払い</h2>
        <p>
          ご利用いただけるオンラインペイメントは当社が指定するものに限られます。<br />
          支払い時期は各種ペイメントサービスとのご契約内容をご確認ください。
        </p>
        <h2>解約について</h2>
        <h3>従量課金サービス</h3>
        <p>
          サービスの性質上、モバイルバッテリーのレンタルを開始してからお客様都合による解約を受け付けることはできません。
        </p>
        <h2>退会</h2>
        <p>
          お客様は所定の手続きに従い、シュ-電のサービスから退会することができます。<br />
          お客様のスマートフォン等の情報端末からアプリケーション等を削除（アンインストール）したのみでは、サービスから退会したことにはなりませんので、ご注意ください。
        </p>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "SpecifiedCommercialTransactions",
  data() {
    return {};
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.specified_commercial_transactions .title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-top: 60px;
  display: inline-block;
  text-align: center;
}
.news-lists {
  max-width: 1200px;
  margin-top: -238px;
  text-align: left;
  background-color: #fff;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 42px 50px;
  font-weight: 400;
  font-size: 22px;
  color: #3d3d3d;
  line-height: 40px;
}
.news-lists > div {
  padding: 10px 0 20px 30px;
}
.news-lists  a {
  color: #3d3d3d;

}
.news-lists h2 {
  font-size: 22px;
  color: #3d3d3d;
  line-height: 30px;
  padding-bottom:  12px;
}
.news-lists h3 {
  font-size: 18px;
  color: #3d3d3d;
  line-height: 30px;
  padding-bottom:  12px;
}
.news-lists p {
  font-weight: 400;
  font-size: 18px;
  color: #3d3d3d;
  line-height: 30px;
  padding-bottom:  30px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/specifiedCommercialTransactions.vue